/*
 * @file: constants.js
 * @description: It Contain action types Related Action constants.
 * @author: navreet
 */

/************ Loading *************/
export const IS_FETCHING = 'IS_FETCHING'

/************ User *************/
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const ROLE_SET = 'ROLE_SET'
export const LOG_OUT = 'LOG_OUT'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_OTHER_PROFILE = 'UPDATE_OTHER_PROFILE'
export const SET_MOBILE = 'SET_MOBILE'
export const FORGOT_EMAIL = 'FORGOT_EMAIL'
export const USER_LIST = 'USER_LIST'
export const LOGIN_BUTTON = 'LOGIN_BUTTON'
export const ERROR_STATUS = 'ERROR_STATUS'
export const LAST_LOGIN = "LAST_LOGIN"

/************Merchant****************** */
export const MERCHANT_LIST = 'MERCHANT_LIST'
export const MERCHANT_REDEEM_LIST = 'MERCHANT_REDEEM_LIST'
export const MERCHANT_REDEEM_DOWNLOAD_LIST = 'MERCHANT_REDEEM_DOWNLOAD_LIST'
export const MERCHANT_PROFILE = 'MERCHANT_PROFILE'
export const UPDATE_SELECTED_MERCHANT_ID = 'UPDATE_SELECTED_MERCHANT_ID'
export const FEATURED_STATUS = 'FEATURED_STATUS'
export const UPDATE_FEATURED = 'UPDATE_FEATURED'
export const FEATURED_LIST = 'FEATURED_LIST'
export const FEATURED_DOWNLOAD_LIST = 'FEATURED_DOWNLOAD_LIST'

/**********Dashboard******************** */
export const DASHBOARD = 'DASHBOARD'
export const REDEEMGRAPH = "REDEEMGRAPH"
export const USERGRAPH = "USERGRAPH"
export const EMISSIONGRAPH = "EMISSIONGRAPH"
export const PIECHART = "PIECHART"

/************Items****************** */
export const ITEMS_LIST = 'ITEMS_LIST'

/************ Admin******************* */
export const ADMIN_LIST = 'ADMIN_LIST'
export const UPDATE_SELECTED_ADMIN_ID = 'UPDATE_SELECTED_ADMIN_ID'

/**************Setiings************* */
export const SETTINGS = "SETTINGS"
export const SOCIAL_MEDIA = "SOCIAL_MEDIA"
export const ROUTE_MAP = "ROUTE_MAP"

/*************Feedback*************** */
export const FEEDBACK_LIST = "FEEDBACK_LIST"

/*************Redeem***************** */
export const REDEEM_LIST = "REDEEM_LIST"

/*************FAQ***************** */
export const FAQ_LIST = "FAQ_LIST"

/*************REWARD***************** */
export const REWARD = "REWARD"

/*************PageInfo***************** */
export const ADMIN_PAGE_INFO = "ADMIN_PAGE_INFO"

/*************Info/PageInfo***************** */
export const TERMS_AND_CONDITION = "TERMS_AND_CONDITION"
